export default __webpack_public_path__ + "static/media/dartsHomePageBg.d44d11a3.jpg";